import * as Yup from 'yup';

export const Step3Schema =Yup.object({
    FirstName: Yup.string().required('El nombre es un campo requerido'),
    LastName: Yup.string().required('Los Apellidos son campos requeridos'),
    address: Yup.string().required('La dirección es un campo requerido '),
    gender: Yup.string().required('El sexo es un campo requerido'),   
    ci: Yup.number().typeError("Formato incorrecto para el CI").positive("No se debe incluir signos").min(11).max(11)
    .required('El CI es un campo requerido'),
    //.matches(visaRegEx, ci.invalidErrorMsg),
    phone: Yup.number().typeError("Formato incorrecto de Teléfono").positive("No se debe incluir signos").min(8).max(8).required('Telefo del trabajo sin formato'),
    //.matches(visaRegEx, telefono.invalidErrorMsg), 
    graduado: Yup.string().required('Debe indicar de que especialidad ha sido graduado'),
    graduationYear: Yup.number().typeError("Formato incorrecto para el año").positive("No se debe incluir signos").min(11).required('Debe indicar el año de graduación'),    
    workplace: Yup.string().required('Debe indicar el Lugar donde Trabaja'),
    position: Yup.string().required('Debe indicar su cargo o plaza de puesto de trabajo'),
    organism: Yup.string().required('Debe indicar el organismo donde trabaja'),
    city: Yup.string().required('Debe indicar la ciudad'),
    workphone: Yup.number().typeError("Formato incorrecto de Teléfono").positive("No se debe incluir signos").min(8).max(8).required('Telefo del trabajo sin formato'),
    
    //.matches(visaRegEx, telf_trab.invalidErrorMsg)
  })

export const Step2Schema = Yup.object({
    thesisTitle: Yup.string().required('El Título de la Tesis es un campo requerido'),
    masterTitle: Yup.string().required('El Título del master es un campo requerido'),
    institutionId: Yup.string().required('El institución donde cursó el master es un campo requerido'),
    countryId: Yup.string().required('El país donde cursó el master es un campo requerido'),
    scienceBranch: Yup.string().required('La Rama de la ciencia es un campo requerido'),
    modality: Yup.string().required('La modalidad es un campo requerido'),
    defenseYear: Yup.number().typeError("Formato incorrecto para el Año de defensa, Debe ser un número").positive("No se debe incluir signos").required('La Año de defensa es un campo requerido'),
    creditsCount: Yup.number().typeError("Formato incorrecto para la cantidad de Creditos, Debe ser un número").positive("No se debe incluir signos").required('El tomo es un campo requerido'),
    programHours: Yup.number().typeError("Formato incorrecto para la cantidad de horas, Debe ser un número").positive("No se debe incluir signos").required('El tomo es un campo requerido'),
    completeTimeYears: Yup.number().typeError("Formato incorrecto, Debe ser un número").positive("No se debe incluir signos").required('El tomo es un campo requerido'),
    partialTimeYears: Yup.number().typeError("Formato incorrecto, Debe ser un número").positive("No se debe incluir signos").required('El tomo es un campo requerido'),
    distanceTimeYears: Yup.number().typeError("Formato incorrecto, Debe ser un número").positive("No se debe incluir signos").required('El tomo es un campo requerido'),
    tome: Yup.number().typeError("Formato incorrecto para el Tomo, Debe ser un número").positive("No se debe incluir signos").required('El tomo es un campo requerido'),
    folio: Yup.number().typeError("Formato incorrecto para el Folio, Debe ser un número").positive("No se debe incluir signos").required('El folio es un campo requerido'),
    number: Yup.number().typeError("Formato incorrecto, Debe ser un número").positive("No se debe incluir signos").required('El Número es un campo requerido') 
})


export const Step1Schema = Yup.object({
    //resumen_tesis: Yup.mixed().required('A file is required'),
   /* .test('fileFormat', 'PDF only', (value) => {
      console.log(value); return value && ['application/pdf'].includes(value.type);
    }),*/
    //titulo_master: Yup.mixed().required('A file is required'),
    //resumen_tesis: Yup.mixed().required('A file is required'),
    //foto: Yup.mixed().required('A file is required'),

})


